export { CO2Icon } from './co2'
